export const genderOptions = [
    {value: "MALE", label:"männlich"},
    {value: "FEMALE", label: "weiblich"},
    {value: "DIVERSE", label: "divers"}
];

export const groupOptions = [
    {value: "admins", label:"Administrator"},
    {value: null, label:"Kunde"},
];

export const rightOptions = [
    {value: "LOCKSYSTEM_UPLOAD", label:"Schließplan PDF"},
    {value: "LOCKSYSTEM_LINK", label: "Schließplan online"},
    {value: "KEY_MANAGEMENT", label:"Schlüsselverwaltung"},
    {value: "AUTHORIZATION", label:"Externe Schlüsselberechtigung"},
    {value: "INVOICING", label:"Bestellung auf Rechnung"}
]

//this right is not a payment options somebody gets to choose
export const paymentTypeDirect = {value:"DIRECT", label: "Bezahlung online", right:"nonvisible"};

export const paymentOptions = [
    {value:"STANDARD", label: "Standard (Bezahlung bei Abholung)"},
    {value:"PAYMENT_LINK", label: "Bezahllink per Mail (Vorauskasse)"},
    {value:"INVOICE", label: "Auf Rechnung", right: "INVOICING"},
    paymentTypeDirect
]

export const orderType = {
    standard: "STANDARD",
    authorization: "AUTHORIZATION",
    request: "REQUEST"
}

export const orderState = {
    CREATED:"CREATED",
    OPEN:"OPEN",
    PAID:"PAID",
    IN_PROGRESS:"IN_PROGRESS",
    IN_PRODUCTION:"IN_PRODUCTION",
    AWAIT_PAYMENT:"AWAIT_PAYMENT",
    AWAIT_USER:"AWAIT_USER",
    CANCELED:"CANCELED",
    COMPLETED:"COMPLETED"
}

export const isOrderAwaitingProcessing = state => state === orderState.OPEN || state === orderState.PAID;
export const isOrderProcessing = state => state === orderState.IN_PROGRESS || state === orderState.IN_PRODUCTION;

export const orderCorrespondenceType = {
    information: "INFORMATION",
    question: "QUESTION",
    keycard: "KEYCARD",
    user_response: "USER_RESPONSE",
    notify_sign: "NOTIFY_SIGN",
    notify_cancel: "NOTIFY_CANCEL",
    notify_response: "NOTIFY_RESPONSE"
}

export const orderStateLabels = new Map([
    [orderState.CREATED, "Zeichnung ausständig"],
    [orderState.OPEN, "Neu"],
    [orderState.PAID, "Bezahlt"],
    [orderState.IN_PROGRESS, "In Bearbeitung"],
    [orderState.IN_PRODUCTION, "In Produktion"],
    [orderState.AWAIT_PAYMENT, "Bezahlung ausständig"],
    [orderState.AWAIT_USER, "Rückmeldung ausständig"],
    [orderState.CANCELED, "Storniert"],
    [orderState.COMPLETED, "Abgeschlossen"]
]);

export const orderCorrespondenceLabels = new Map([
    [orderCorrespondenceType.information, "Information"],
    [orderCorrespondenceType.question, "Nachfrage"],
    [orderCorrespondenceType.keycard, "Sicherungskarte"],
    [orderCorrespondenceType.user_response, "Kundenantwort"],
    [orderCorrespondenceType.notify_sign, "Erinnerung Zeichnung"],
    [orderCorrespondenceType.notify_cancel, "Automat. Stornierung"],
    [orderCorrespondenceType.notify_response, "Erinnerung Nachfrage"]
]);

export const paymentStates = {
    AWAIT_USER: "AWAIT_USER",
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
    CANCELED: "CANCELED"
}

export const paymentStateLabels = new Map([
    [paymentStates.AWAIT_USER, "Bezahlung offen"],
    [paymentStates.PENDING, "Bestätigung durch Stripe ausständig"],
    [paymentStates.SUCCESS, "Bezahlt"],
    [paymentStates.FAILED, "Fehlgeschlagen"],
    [paymentStates.CANCELED, "Storniert"]
]);

export const yearsOptions = [];

for (let i = new Date().getFullYear(); i >= 2009; i--) {
    yearsOptions.push({value:i, label:i});
}

export const stripeState = {
    INIT: "INIT",
    FAILED: "FAILED",
    SUCCESS: "SUCCESS"
}